var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var getImageDimensionsBasedOnSizeType = function (avatarSize, borderColor, dataUrl) {
    var base = {
        position: 'relative',
        borderColor: borderColor,
        overflow: 'hidden',
        backgroundImage: "url(".concat(dataUrl, ")"),
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    };
    switch (avatarSize) {
        case 'xs':
            return __assign(__assign({}, base), { height: '24px', width: '24px' });
        case 'sm':
            return __assign(__assign({}, base), { height: '32px', width: '32px' });
        case 'md':
            return __assign(__assign({}, base), { height: '40px', width: '40px' });
        case 'md-lg':
            return __assign(__assign({}, base), { height: '48px', width: '48px' });
        case 'header':
            return __assign(__assign({}, base), { height: '120px', width: '120px' });
        case 'lg':
            return __assign(__assign({}, base), { height: '56px', width: '56px' });
    }
};
export var avatar = function (avatarSize, displayBorder) {
    switch (avatarSize) {
        case 'xs':
            return "rounded-full ".concat(displayBorder ? "border-2" : '');
        case 'sm':
            return "rounded-full ".concat(displayBorder ? "border-2" : '');
        case 'md':
            return "rounded-full ".concat(displayBorder ? "border-2" : '');
        case 'md-lg':
            return "rounded-full ".concat(displayBorder ? "border-2" : '');
        case 'header':
            return "rounded-full ".concat(displayBorder ? "border-4" : '');
        case 'lg':
            return "rounded-full ".concat(displayBorder ? "border-4" : '');
    }
};
//# sourceMappingURL=avatar.styles.js.map